import { Routes } from '@angular/router';
import { TabCalculatedSignalsPageComponent } from './tab-calculated-signals/tab-calculated-signals.page';
import { TabConfigurationsPageComponent } from './tab-configurations/tab-configurations.page';
import { TabSettingsPageComponent } from './tab-settings/tab-settings.page';
import { TabSignalsPageComponent } from './tab-signals/tab-signals.page';
import { TabsPageComponent } from './tabs/tabs.page';

export const routes: Routes = [
    {
        path: 'tabs',
        component: TabsPageComponent,
    },
    {
        path: 'signals',
        component: TabSignalsPageComponent,
    },
    {
        path: 'configurations',
        component: TabConfigurationsPageComponent,
    },
    {
        path: 'settings',
        component: TabSettingsPageComponent,
    },
    {
        path: 'calculated-signals',
        component: TabCalculatedSignalsPageComponent,
    },
    {
        path: '',
        redirectTo: '/tabs',
        pathMatch: 'full',
    },
    {
        path: 'help',
        loadComponent: () => import('./help/help.page').then((m) => m.HelpPage),
    },
];
